<template>
  <SelectSearchDropdown
    :options="countries"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
import countries from '../constants/countries';
import SelectSearchDropdown from './SelectSearchDropdown.vue';

export default {
  name: 'country-select',

  components: { SelectSearchDropdown },

  data() {
    return {
      countries: countries.map(country => ({ value: country.name, text: country.name })),
    };
  },

  created() {
    if (this.value) {
      return;
    }

    // Set default country from browser timezone settings
    const countryFromTimezone = ((Intl.DateTimeFormat().resolvedOptions().timeZone || '').split('/') || [])[1];
    if (countryFromTimezone && countries.map(v => v.name).includes(countryFromTimezone)) {
      this.$emit('input', countryFromTimezone);
      return;
    }

    // Set default country from browser locale settings
    const countryCode = (navigator.language.split('-')[1] || navigator.language || '');
    const country = countries.find(v => v.code === countryCode);
    if (country) {
      this.$emit('input', country.name);
    }
  },

  props: { value: String },
};
</script>
